import { createRouter, createWebHistory } from 'vue-router'
import IndexPage from '../views/Index.vue'
import BuildingDetail from '../views/BuildingDetail.vue'
import AdminLogin from '../views/AdminLogin.vue'
import SetPage from '../views/Admin.vue'
import LoginPage from '../views/Login.vue'
import RegisterPage from '../views/Register.vue'
import ForgotPage from '../views/Forgot.vue'
import MePage from '../views/Me.vue'
import BuildingSnapshot from '../views/BuildingSnapshot.vue'
import { clearUserAuth, isTokenValid } from '../utils/auth.js'

const routes = [
  {
    path: '/index',
    name: 'Index',
    component: IndexPage
  },
  {
    path: '/building/:id',
    name: 'BuildingDetail',
    component: BuildingDetail,
    props: true
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterPage
  },
  {
    path: '/forgot',
    name: 'Forgot',
    component: ForgotPage
  },
  {
    path: '/me',
    name: 'Me',
    component: MePage,
    meta: { requiresUser: true }
  },
  {
    path: '/building-snapshot/:id',
    name: 'BuildingSnapshot',
    component: BuildingSnapshot,
    props: true,
    meta: { requiresUser: true }
  },
  {
    path: '/admin',
    alias: '/admin/',
    name: 'AdminLogin',
    component: AdminLogin
  },
  {
    path: '/set',
    name: 'Set',
    component: SetPage,
    meta: { requiresAdmin: true }
  },
  {
    path: '/',
    redirect: '/index'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.requiresAdmin) {
    if (!isTokenValid('admin_token')) {
      next({ path: '/admin', query: { redirect: to.fullPath } })
      return
    }
  }

  if (to.meta && to.meta.requiresUser) {
    if (!isTokenValid('user_token')) {
      clearUserAuth()
      next({ path: '/login', query: { redirect: to.fullPath } })
      return
    }
  }

  next()
})

export default router
